import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["result", "button"]
  async check(event) {
    event.preventDefault()
    this.buttonTarget.disabled = true
    this.resultTarget.textContent = "Checking Salesforce…"
    try {
      const response = await fetch(this.element.action, { method: "POST", headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" } })
      if (!response.ok) throw new Error("The connection could not be checked.")
      const result = await response.json()
      const missing = (result.hosts || []).filter(host => !host.mapped).map(host => host.name)
      this.resultTarget.textContent = result.message + (missing.length ? ` Review Salesforce user mapping for: ${missing.join(", ")}.` : "")
    } catch (error) { this.resultTarget.textContent = error.message }
    finally { this.buttonTarget.disabled = false }
  }
}
